module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": _vm.noShadow ? 'hover' : 'always',
      "body-style": 'background-color: ' + _vm.siteBgColor(_vm.localData.status)
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8.52
    }
  }, [_c('el-col', {
    class: _vm.mapL ? 'pull-right' : 'pull-left',
    attrs: {
      "align": (_vm.mapR || _vm.mapL) ? (_vm.noM ? 'center' : 'left') : 'center',
      "span": (_vm.mapR || _vm.mapL) ? (_vm.noM ? 24 : 12) : 24
    }
  }, [(!_vm.hideSite) ? _c('h3', {
    class: _vm.titleClass(_vm.localData.status)
  }, [_c('b', [_vm._v(_vm._s(_vm.localData.siteName))])]) : _vm._e(), _vm._v(" "), (!_vm.hideSite && _vm.localData.telcoSiteId) ? _c('h5', {
    staticClass: "text-muted"
  }, [_c('b', [_vm._v(_vm._s(_vm.localData.telcoSiteId))])]) : _vm._e(), _vm._v(" "), (!_vm.hideSite && _vm.localData.siteId) ? _c('h5', [_c('span', {
    class: _vm.titleClass(_vm.localData.status)
  }, [_vm._v(_vm._s(_vm.localData.status) + ":")]), _vm._v(" Site ID: "), _c('b', [_vm._v(_vm._s(_vm.localData.siteId))])]) : _vm._e(), _vm._v(" "), (!_vm.hideSite && _vm.localData.siteGroup) ? _c('h5', [_vm._v("Site Group: "), _c('b', [_vm._v(_vm._s(_vm.localData.siteGroup))])]) : _vm._e(), _vm._v(" "), (!_vm.noStructure && _vm.localData.structure && (_vm.localData.structure.name || _vm.localData.structure.height)) ? _c('div', {
    attrs: {
      "align": _vm.mapR ? 'left' : 'center',
      "span": 24
    }
  }, [_vm._v("\n         Structure: "), (_vm.localData.structure.name) ? _c('strong', [_vm._v(_vm._s(_vm.localData.structure.name))]) : _vm._e(), _vm._v(" "), (_vm.localData.structure.height) ? _c('span', [_vm._v(" | "), _c('strong', [_vm._v(_vm._s(_vm.localData.structure.height))]), _vm._v("m.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.localData.structureName || _vm.localData.structureHeight) ? _c('div', {
    attrs: {
      "align": _vm.mapR ? 'left' : 'center',
      "span": 24
    }
  }, [_vm._v("\n         Structure: "), (_vm.localData.structureName) ? _c('strong', [_vm._v(_vm._s(_vm.localData.structureName))]) : _vm._e(), _vm._v(" "), (_vm.localData.structureHeight) ? _c('span', [_vm._v(" | "), _c('strong', [_vm._v(_vm._s(_vm.localData.structureHeight))]), _vm._v("m.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.localData.latitude && _vm.localData.longitude && !_vm.noM) ? _c('el-col', {
    attrs: {
      "span": (_vm.mapR || _vm.mapL) ? 12 : 24
    }
  }, [(!_vm.useLeaflet) ? _c('google-map', {
    attrs: {
      "lat": _vm.localData.latitude,
      "lng": _vm.localData.longitude,
      "map-type": _vm.mapType,
      "map-style": _vm.mapStyle,
      "zoom": _vm.zoom,
      "draggable": _vm.draggable,
      "show-nominal": "",
      "markers": _vm.markers,
      "options": ['option', 'access', 'power', 'building'],
      "optionIcons": ['fa fa-bullseye', 'fa fa-road', 'fa fa-plug', 'fa fa-home']
    }
  }) : _c('leaflet-map', {
    attrs: {
      "height": _vm.height,
      "width": _vm.width,
      "lat": _vm.localData.latitude,
      "lng": _vm.localData.longitude,
      "caption": _vm.localData.siteName,
      "zoom": _vm.zoom,
      "allow-zoom": _vm.allowZoom,
      "draggable": _vm.draggable
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6221b24f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteCard.vue
// module id = 1525
// module chunks = 0